import React from "react";
import clsx from "clsx";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import * as Glob from "src/Globale";
import { _ButtonAPI } from "../../components/";

const useStyles = makeStyles(({ palette, spacing }: Theme) => ({
    closeButton: {
        position: "absolute",
        right: spacing(2),
        top: spacing(2),
        color: palette.grey[500]
    },
    warning: {
        background: palette.warning.light
    },
    info: {
        background: palette.info.light
    },
    success: {
        background: palette.success.light
    },
    error: {
        background: palette.error.main
    }
}));

interface IDialogProps {
    Open: boolean;
    Title: string;
    Actions: React.ReactNode;
    OnClose: () => void;
    Type?: Glob.DialogType;
}

export const _Dialog: React.FC<IDialogProps> = ({ Open, Title, Actions, Type, OnClose, ...rest }) => {
    const classes = useStyles();

    return (
        <Dialog fullWidth maxWidth="xs" open={Open} onClose={OnClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title" className={clsx(Type && classes[Type])}>
                <Typography variant="subtitle2" component="p">
                    {Title}
                </Typography>
                <IconButton aria-label="close" className={classes.closeButton} onClick={OnClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>{rest.children}</DialogContent>
            <DialogActions>{Actions}</DialogActions>
        </Dialog>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/common/Dialog.tsx